import React from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { showCreateOUModal } from 'actions/modal';
import { clearOrgGeneralInfoForm, getShortUrls } from 'actions/organisation';

const CreateOUButton = (props) => {
  const dispatch = useDispatch();
  const clickBtn = () => {
    let cb = () => {
      dispatch(showCreateOUModal(true));
    };
    dispatch(getShortUrls());
    dispatch(clearOrgGeneralInfoForm(cb));
  };
  return (
    <React.Fragment>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ marginTop: '2px' }}>
        <button
          type="button"
          className="ui labeled icon button mrbs color-button color-white right-hand-side-button"
          onClick={clickBtn}
        >
          <i className="plus icon" />
          {APP.LANGUAGE.CreateOU.BtnText}
        </button>
      </Container>
      <Container fluid as={Media} at="tablet">
        <button
          type="button"
          className="ui labeled icon button mrbm color-button color-white right-hand-side-button"
          onClick={clickBtn}
        >
          <i className="plus icon" />
          {APP.LANGUAGE.CreateOU.BtnText}
        </button>
      </Container>
      <Container fluid as={Media} at="mobile">
        <button type="button" className="ui labeled icon button mrbml color-button color-white" onClick={clickBtn}>
          <i className="plus icon" />
          <span style={{ fontSize: '0.9rem' }}>{APP.LANGUAGE.CreateOU.BtnText}</span>
        </button>
      </Container>
    </React.Fragment>
  );
};

export default CreateOUButton;
